module.exports = __webpack_public_path__ + "img/45ne.8fdb33a6.svg";